module.exports = __webpack_public_path__ + "static/media/dabir.d16cca58.jpeg";